import Vue from 'vue'
import axios from 'axios'
import { getMe, getPermission } from '@/service/user/user'
import base_Url from './auth-access'

export default async function protectRoute(to, from) {
  const token = sessionStorage.getItem('token')

  if (!token) {
    sessionStorage.setItem('redirectAfterLogin', to.fullPath)
    if (to.name !== 'home') {
      return { redirect: { name: 'home' } }
    }
    return { redirect: null } 
  }
  axios.defaults.headers.common.Authorization = `Bearer ${token}`

  const merchantId = Number(sessionStorage.getItem('veripagID'))
  const hasMerchant = Number.isInteger(merchantId) && merchantId > 0
  const requiresMerchant = to.matched.some(record => record.meta.requiresMerchant)
  if (requiresMerchant && !hasMerchant) {
    return { redirect: { name: 'select-merchant' } }
  }

    const termsAccepted = sessionStorage.getItem('termsAccepted') === 'true'

    if (!termsAccepted) {
      const currentUser = await getMe().catch(() => null)

      if (currentUser?.status === 200) {
      const reviewTermsEcs = Array.isArray(currentUser.data?.review_terms_ecs)
        ? currentUser.data.review_terms_ecs
        : []

      sessionStorage.setItem('reviewTermsEcs', JSON.stringify(reviewTermsEcs))

      if (to.name !== 'review-terms'
        && (reviewTermsEcs.length || Number(currentUser.data?.review_terms) === 1)) {
        return { redirect: { name: 'review-terms' } }
      }
    }
  }

  try {
    const loader = document.getElementById('loading-bg')
    if (loader) {
      loader.style.display = 'block'
      loader.style.position = 'fixed'
      loader.style.zIndex = 10
    }

    const authResponse = await axios.post(`${base_Url()}users/authenticate`).catch(() => null)
    
    const userId = authResponse?.data?.id

    if (userId) {
      const meResponse = await getMe().catch(() => null)
      if (meResponse?.data?.permissions) {
        sessionStorage.setItem('menuPermissions', JSON.stringify(meResponse.data.permissions))
      }
    }
    
    if (userId && !sessionStorage.getItem('permissions')) {
      const permissionsRes = await getPermission(userId).catch(() => null)
      if (permissionsRes?.data) {
        sessionStorage.setItem('permissions', JSON.stringify(permissionsRes.data))
        return { success: true }
      }
    }

    if (sessionStorage.getItem('termsAccepted') === 'true') {
      sessionStorage.removeItem('termsAccepted')
    }

    return { success: true } 
  } catch (err) {
    console.error(' erro inesperado:', err)
    sessionStorage.setItem('redirectAfterLogin', to.fullPath)
    if (to.name !== 'home') {
      return { redirect: { name: 'home' } }
    }
    return { redirect: null }
  }
}
